module.exports = __webpack_public_path__ + "static/media/mainChartDescr1.59358c96.png";